import {useSearchParams} from "react-router-dom";
import useCustomPaging from "@/hooks/useCustomPaging";
import {formatCapitalWords} from "@/utils";

const useGenericSelectFilter = (key, options, keyFilter = key) => {
  const [searchParams] = useSearchParams()
  const [, changeFilterWithoutPage] = useCustomPaging()
  const currentSelectValue = searchParams.get(keyFilter) ?? ''
  const text = formatCapitalWords(key)
  const allOption = {
    value: '',
    label: `Semua ${text}`
  }
  
  const getSelectedValue = () => {
    const found = options.find(v => v.value === currentSelectValue)
    return found ?? allOption
  }
  const getSelecOptions = () => ([
    allOption,
    ...options,
  ])
  const handleChangeValue = (v) => {
    changeFilterWithoutPage(keyFilter, v.value)
  }
  
  return [
    currentSelectValue,
    getSelectedValue(),
    getSelecOptions(),
    handleChangeValue
  ] as const
}

export default useGenericSelectFilter